var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "draggable",
    _vm._b(
      {
        attrs: {
          list: _vm.widget.widgetList,
          "item-key": "id",
          tag: "transition-group",
          "component-data": { name: "fade" },
          handle: ".drag-handler",
          move: _vm.checkContainerMove,
        },
        on: {
          end: function (evt) {
            return _vm.onDragEnd(evt, _vm.widget.widgetList)
          },
          add: function (evt) {
            return _vm.onDragAdd(evt, _vm.widget.widgetList)
          },
          update: _vm.onDragUpdate,
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function (ref) {
              var subWidget = ref.element
              var swIdx = ref.index
              return [
                _c(
                  "div",
                  { staticClass: "form-widget-list" },
                  [
                    "container" === subWidget.category
                      ? [
                          _c(subWidget.type + "-widget", {
                            key: subWidget.id,
                            tag: "component",
                            attrs: {
                              widget: subWidget,
                              designer: _vm.designer,
                              "parent-list": _vm.widget.widgetList,
                              "index-of-parent-list": swIdx,
                              "parent-widget": _vm.widget,
                            },
                          }),
                        ]
                      : [
                          _c(subWidget.type + "-widget", {
                            key: subWidget.id,
                            tag: "component",
                            attrs: {
                              field: subWidget,
                              designer: _vm.designer,
                              "parent-list": _vm.widget.widgetList,
                              "index-of-parent-list": swIdx,
                              "parent-widget": _vm.widget,
                              "design-state": true,
                            },
                          }),
                        ],
                  ],
                  2
                ),
              ]
            },
          },
        ]),
      },
      "draggable",
      { group: "dragGroup", ghostClass: "ghost", animation: 400 },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }